<template>
    <div class="visitink" style="padding-top:0px;">
        <div class="visitink-title">
            <h3>欢迎进入{{vtitle}}</h3>
            <div class="visitink-title-theme">
                <span>主题：</span>
                <span style="width: 80%;display: inline-block;vertical-align: top;">{{vtheme?vtheme:'暂无主题'}}</span>
            </div>
            <div class="visitink-title-name">
                <span>受邀嘉宾：</span>
                <span>{{vname?vname:'暂无嘉宾'}}</span>
            </div>
        </div>
        <div class="visitink-body">
            <div >
                <h4 style="padding-bottom: 14px;border-bottom: 1px solid #eee;">邀请内容</h4>
                <p>{{vcontent?vcontent:'暂无邀请内容'}}</p>
            </div>
            <div >
                <h4>到访时间</h4>
                <p>{{vreachTime?vreachTime:'暂无到访时间'}}</p>
            </div>
            <div>
                <h4>详细地址</h4>
                <p class="visitink-body-address" style="color:#1677FF">
                    <van-field
                        v-model="vaddress"
                        value="vaddress"
                        rows="1"
                        autosize
                        disabled
                        type="textarea"
                        placeholder="请输入留言"
                        :border="false"
                        id="textAreas"
                        style="padding:0;width:88%;border: none;outline:0 none;background: transparent;"
                    />
                    <!-- <textarea  type="text" v-model="vaddress" value="vaddress" readonly id="textAreas" disabled style="width:80%;border: none;outline:0 none;margin-top: 12px;background: transparent;overflow-y: visible;" ></textarea> -->
                    <button id="copy" @click="copy" style="border: none;background:transparent;">复制</button>
                </p>
            </div>
            <div >
                <h4>邀约人</h4>
                <p>{{vinvitation?vinvitation:'暂无邀约人'}}</p>
            </div>
            <div >
                <h4>日期</h4>
                <p>{{vtime? xy.moment(vtime).format("YYYY-MM-DD"):'暂无日期'}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
     name: '',
     data () {
      return {
          vtitle:'晓羊中学',
          vtheme:'学校第十二届运动会',
          vname:'aaa',
          vcontent:'你好，这里是一个比较长的邀请内容，较长的邀请比较长的邀比较 长的邀请 比较长的邀请请 比较长的邀请 比较长的比较请长的邀请比较长的邀请邀请… ',
          vreachTime:'2020-12-12',
          vaddress:'海淀区中关村科贸大厦B座1902海淀区中关村科贸大厦',
          vinvitation:'哈哈哈',
          vtime:'2020-11-11'
      }
    },
    created(){
        this.getDetailInfo()
    },
    methods: {
        //获取访客邀请详情
        async getDetailInfo () {
          let params = {
              inatationDetailInfoID:this.$route.query.inatationDetailInfoID ? this.$route.query.inatationDetailInfoID : 21,
              accountID:this.$route.query.accountID ? this.$route.query.accountID: 2,
              invatationInfoID:this.$route.query.invatationInfoID ? this.$route.query.invatationInfoID : 18
          }  
          let res = await this.xyapi.get(
            this.xyMApi+'/vst' + "/invatation/GetDetailForPhone",params
           // 'http://devpczx.xiaoyangedu.net:9092' + '/vst/invatation/GetDetailForPhone', params
          )
          if (res.success) {
            if (res.data !== null) {
            this.vtitle = res.data.invatationInfo.InvatationSchoolName    //学校
            this.vtheme = res.data.invatationInfo.InvatationTitle     //主题
            this.vname = res.data.invatationDetailInfo.InvatationFullName      //受邀人
            this.vcontent = res.data.invatationInfo.InvatationContent   //内容
            this.vreachTime = res.data.invatationInfo.InvatationArriveTime   //到访时间
            this.vaddress = res.data.invatationInfo.InvatationArriveAddress?res.data.invatationInfo.InvatationArriveAddress:'暂无地址1111暂无地址1111暂无地址1111暂无地址1111暂无地址1111暂无地址1111'    //地址
            this.vinvitation = res.data.invatationInfo.InvatationUser    //邀约人
            this.vtime = res.data.invatationInfo.CreateByDate     //日期
            }
          } else {
            this.xy.msgError(res.msg)
          }
        },
        copy(){
            console.log(11111)
            //获取input对象
            var obj = document.getElementById("textAreas");
            // var u = navigator.userAgent;
            // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            //如果是ios端
            // if(isiOS){
                // 获取元素内容是否可编辑和是否只读
                var editable = obj.contentEditable;
                var readOnly = obj.readOnly;
                
                // 将对象变成可编辑的
                obj.contentEditable = true;
                obj.readOnly = false;
            
                // 创建一个Range对象，Range 对象表示文档的连续范围区域，如用户在浏览器窗口中用鼠标拖动选中的区域
                var range = document.createRange();
                //获取obj的内容作为选中的范围
                // range.selectNodeContents(obj);
                range.selectNode(obj);
                var selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
            
                obj.setSelectionRange(0, 999999);  //选择范围，确保全选
                //恢复原来的状态
                obj.contentEditable = editable;
                obj.readOnly = readOnly;
                //如果是安卓端    
            // }else{
            //     debugger
            //     obj.select();
            // }
            try{
                if(document.execCommand("Copy","false",null)){
                this.xy.msgSuc('复制成功。')
                }else{
                this.xy.msgError('复制失败！请手动复制。')
                }
            }catch(err){
                this.xy.msgError('复制错误！请手动复制！')
            }
            
        }
    }
}
</script>
<style lang='less' scoped>
.visitink{
    position: absolute;
    top: 0;
    width: 100%;
    height: auto;
    // background: #ffffff;
    .visitink-title{
        // position: relative;
        color: #ffffff;
        background: url(~@/assets/schoolAffairs/bg.png) no-repeat;
        height:100%;
        width:100%;
        overflow: hidden;
        background-size:cover;
        padding-bottom: 60px;
        h3{
            text-align: center;
            font-size: 36px;
            margin: 40px;
        }
        div{
            margin-left: 20px;
        }
        .visitink-title-theme{
            font-size: 32px;
        }
        .visitink-title-name{
            font-size: 26px;
            margin-top:20px
        }
    }
    .visitink-body{
        background: #ffffff;
        padding: 10px 0 0 0;
        position: relative;
        top:-18px;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
        div{
            h4{
                font-size: 30px;
                padding: 30px 35px 8px 35px;
                font-weight: 600;
            }
            p{
                padding: 10px 35px;
                margin-top: 6px;
                border-bottom: 1px solid #eeeeee;
                padding-bottom: 30px;
                color: #676767
            }
            .visitink-body-address{
                display: flex;
                justify-content: space-between;
            }
        }
    }
}
textarea[disabled]{
    -webkit-opacity:1;
    opacity: 1;
}
/deep/ .van-field__control:disabled{
    color: rgb(22, 119, 255);
    
}
/deep/ .van-cell{
    border: none;
}
</style>